// extracted by mini-css-extract-plugin
export default {"number_container":"artpool-countdown_number_container__24U0W"};